import { useMutation } from 'react-query';
import { createRegisterResultProduct } from 'apis/registerResult';

const useMutationCreateRegisterResultProduct = () => {
  const { mutateAsync, ...rest } = useMutation(createRegisterResultProduct);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationCreateRegisterResultProduct;
